export const lang = {
	home : '首页',
	name : '中文',
	Best_sellers : '热卖产品',
	Business : '商务合作',
	Support : '服务与支持',
	About_us : '关于我们',
	SDK : '二次开发',
	language : 'English',
	
	Robot : '机器人',
	Spray_disinfection:'喷雾消毒',
	UVC_disinfection:'紫外灯消毒',
	Delivery : '送餐',
	Receptionist  : '迎宾',
	Companion :'陪护',
	Buy : '购买产品',
	Become_an_agent : '区域代理',
	Our_customers:'合作客户',
	After_sale_service : '售后服务',
	Company_profile : '公司简介',
	News :'新闻动态',
	Contact_us : '联系我们',
	Input_phone : '请输入电话',
	For_details : '我要询价',
	tel : '15986723663',
	
	News1 :'更多新闻',
	
	index1 : '明星产品',
	
	AI_database :'自主研发的基于云端的AI数据库、语意理解及分析系统可以提供SDK， 支持二次开发。',
	Material_MTPE :'自主改性新型高分子弹性材料M-TPE,光滑柔软弹性优于TPE，价格优于硅胶',
	Mobile_intelligent :'自主研制开发的多系列固定移动智能硬件平台全方位支持二次开发',
	
	Uniquely_designed :'全球首款多种智能消毒模式，极致的消毒设计，多种模式可智能语音控制，让人机交互体验更进一步，消毒从此安全有效。',
	Omnidirectional :'3D全向避障',
	Equipped :'为追求更高的安全性，本机搭载超声波+红外传感器，配合全新模块化地盘，任意角度，遇障即停，随转即走。',

	automatic_disinfection : '自动消毒机器人是由人工智能技术公司制造的一种可编程的、最先进的机器人仪器。你可以通过一个简单易用的iPad进行无需人工干预的每晚消毒控制器。浓缩紫外线能有效杀灭细菌等有害微生物，最高消毒率达99.99%。',
	Video_introduction : '视频介绍',
	uvc_title : '省心消毒·值得拥有',
	uvc_p : '自主专利移动底盘，全向避障；遇到障碍，可以立即规划新路线和按新路线避开; 3D全向避障，智能路线规划等多项技术确保机器可以自动完成消毒任务，并且可以节省人力。',
	uvc_title1 : '紫外杀菌·环保无害',
	uvc_p1 : '紫外线杀菌消毒是利用适当波长的紫外线能够破坏微生物机体细胞中的DNA（脱氧核糖核酸）或RNA（核糖核酸）的分子结构，造成生长性细胞死亡和（或）再生性细胞死亡，达到杀菌消毒的效果。紫外线消毒技术是基于现代防疫学、医学和光动力学的基础上，利用特殊设计的高效率、高强度和长寿命的UVC波段紫外光照射流水，将水中各种细菌、病毒、寄生虫、水藻以及其他病原体直接杀死。紫外线消毒是一种物理方法，它不向水中增加任何物质，没有副作用，这是它优于氯化消毒的地方，它通常与其它物质联合使用，常见的联合工艺有UV+H2O2、UV+H2O2+O3、UV+TiO2，这样，消毒效果会更好。',
	uvc_p2 : '应用场景',
	uvc_p3 : '医院，工厂，酒店，办公室等...',
	
	generation :'基于新一代全自主定位导航方案，机器人采用激光slam技术和多传感器，负责餐厅菜品从后厨到餐桌的配送，循环移动到等候区的顾客配送零食，并能用生日蛋糕给生日顾客惊喜，提高服务效率，帮助餐厅优化人员，带来附加增值服务。',
	Delivery1 : '产品参数',
	Delivery2 : '产品名称',
	Delivery3 : '智能送餐机器人',
	Delivery4 : '产品功能',
	Delivery5 : '食品运送',
	Delivery6 : '最大移动速度',
	Delivery7 : '0.5m/s',
	Delivery8 : '高度',
	Delivery9 : '120cm',
	Delivery10 : '承重',
	Delivery11 : '200kg',
	Delivery12 : '雷达范围',
	Delivery13 : '0.15m-16m',
	Delivery14 : '额定功率',
	Delivery15 : '36V/15A 21A.H锂电池',
	Delivery16 : '网络',
	Delivery17 : '4G、Wifi',
	Delivery18 : '物理结构',
	Delivery19 : '可选择2层、3层,长36*W35*H25cm',
	Delivery20 : '底盘直径',
	Delivery21 : '44cm',
	Delivery22 : '避障方式',
	Delivery23 : '激光雷达、超声波',
	Delivery24 : '净重量',
	Delivery25 : '70KG',
	Delivery26 : '充电方式',
	Delivery27 : '自动、手动',
	Delivery28 : '定制',
	Delivery29 : '贴牌生产、原厂',
	Delivery30 : '应用场景：餐厅，火锅店，超市，酒店...',

	welcome1 : '产品参数',
	welcome2 : '产品名称',
	welcome3 : '智能商业迎宾机器人',
	welcome4 : '产品功能',
	welcome5 : '1．礼仪迎宾：红外感应、主动语音交流、自定义语音播报2．语言：中国多数方言及英语3. 肢体动作：弯腰、鞠躬、敬礼、挥手等',
	welcome6 : '主机电压',
	welcome7 : 'DC36V、充电DC42V',
	welcome8 : '网络',
	welcome9 : '4G、WIFI',
	welcome10 : '身体材质',
	welcome11 : '高级改性M-TPE',
	welcome12 : '身高',
	welcome13 : '标准166cm，可定制',
	welcome14 : '总重量',
	welcome15 : '45KG',
	welcome16 : '骨骼',
	welcome17 : '复合不锈钢',
	welcome18 : '肤色',
	welcome19 : '正常肤色，可定制',
	welcome20 : '眼球',
	welcome21 : '黑色、蓝色、绿色',
	welcome22 : '可选配',
	
	buy1 : '购买产品',
	buy2 : '深圳全智能机器人科技有限公司',
	buy3 : '地址：深圳市宝安区福永街道凤凰社区兴业三路七号美盈（凤凰）智汇创新园A6栋101。',
	buy4 : '电话：0755-23226813',
	buy5 : '手机：15986723663 倪经理',
	buy6 : '微信：15986723663',
	buy7 : 'QQ：2571177189',
	buy8 : 'E-mail：2571177189@qq.com',
	buy9 : '电话：+86 075523226813',
	buy10 : '官网网址：www.ai-aitech.cn',
	buy11 : '阿里巴巴：https://airobot1688.1688.com/',

	Sold1 : '售后服务',
	Sold2 : '服务说明',
	Sold3 : '提供7*24小时网络咨询服务。',
	Sold4 : '软件部分：一次购买，终身免费自动升级。',
	Sold5 : '机电部分：一年保修，三年保质。在一年之内，如果出现非人为损坏，本公司提供免费保修。',
	Sold6 : '一年之后，三年之内。本公司提供有偿维护和升级。',
	Sold7 : '注：如果您是代销商户，我们还为您录制了专业化的宣导视频、详细的《使用说明书》，也可以为您免费提供销售工程师的技术培训。',
	Sold8 : '服务内容',
	Sold9 : '1年保修 | 3年质保 | 软件终身免费升级 | |24小时咨询 | 免费远程协助',
	Sold10 : '联系方式',
	Sold11 : '地址：深圳市宝安区福永街道凤凰社区兴业三路七号美盈（凤凰）智汇创新园A6栋101',
	Sold12 : '电话： 075523226813',
	Sold13 : '网址：www.ai-aitech.cn',
	Sold14 : '邮箱：info@ai-aitech.com',
	
	about1 : '公司简介',
	about2 : '全智能科技（AI-Tech）是深圳全智能机器人科技有限公司[Shenzhen All Intelligent Technology Co.，Ltd. ]的简称，沿革于2013年，创建于2016年8月18日。顾名思义，全智能科技（AI-Tech）是以研发、生产、销售人工智能技术服务和产品的国家级高新技术企业。我们利用自主开发的核心技术，以“虚实结合、软硬兼备”的模式，致力于打造实用型的新型人工智能技术和AI科技共享平台。',
	about3 : '公司大事件',
	about4 : '开始',
	about5 : '深圳全智能机器人科技有限公司（AI-Tech）的创建日。',
	about6 : '第一款机器人',
	about7 : '菲菲aT001原型机研发完成，投入生产。',
	about8 : '获得软件著作权',
	about9 : 'AI智能控制及语音管理系统投入商用上线，并申请国家软件著作权。',
	about10 : '英文对话上线',
	about11 : 'AI智能英文问答数据平台（智能英文问答数据库）投入商用上线，并申请国家软件著作权。',
	about12 : '高分子皮肤投入使用',
	about13 : '关键新型高分子材料M-TPE投入仿真机器人身体皮肤材料生产和使用。',
	about14 : '移动机器人上线',
	about15 : '移动姿态核心算法和维持系统投入商用上线，并申请国家软件著作权。',
	about16 : '终端管理平台上线',
	about17 : '基于机器人二次开发及终端管理平台系统投入商用上线。是机器人二次开发的核心平台，也是大脑终端的核心管控平台。',
	about18 : '获得软件著作权',
	about19 : 'AI智能中文问答数据平台（智能中文问答数据库）投入商用上线，并申请国家软件著作权。',
	about20 : '消毒机器人上线',
	about21 : '移动喷雾式消毒机器人原型机SRT-1系列研发完成，并投入生产。2019年12月09日，获得国家高新技术企业证书。',
	about22 : '移动机械臂机器人投入生成',
	about23 : '智能服务（智能机械臂）机器人原型机SRT-202系列研发完成，并投入生产。',
	about24 : '紫外灯消毒机器人上线',
	about25 : '移动紫外灯消毒机器人原型机SRT-3系列研发完成，并投入生产。',
	about26 : '科研成果',
	about27 : '近几年公司大力研发，取得大量优秀成果，点击查看更多详情',
	
	Contact1 : '联系我们',
	Contact2 : '地址：深圳市宝安区福永街道凤凰社区兴业三路七号美盈（凤凰）智汇创新园A6栋101',
	Contact3 : '电话：0755-23226813',
	Contact4 : '手机：15986723663 倪经理',
	Contact5 : '微信：15986723663',
	Contact6 : 'QQ：2571177189',
	Contact7 : 'E-mail：2571177189@qq.com',
	Contact8 : '官网网址：www.ai-aitech.cn',
	Contact9 : '阿里巴巴：https://airobot1688.1688.com/',
	
	regist1 : '新用户可领专享红包',
	regist2 : '姓名：',
	regist3 : '请输入姓名',
	regist4 : '电话：',
	regist5 : '请输入电话号码',
	regist6 : '邮箱：',
	regist7 : '请输入邮箱',
	regist8 : '留言：',
	regist9 : '提交',
	regist10 : '例如我想了解消毒机器人',

	technology1 : '自研系统及平台',
	technology2 : '2017年上线，英文智能语音数据库、智能语音管理系统，2019年，上线中文AI数据平台、后台机器人终端管理平台、移动控制及姿态维持算法。',
	technology3 : '智能迎宾机器人',
	technology4 : '1.拥有自主知识产权（专利：201821461522.1 / CN201811033797）',
	technology5 : '2.整个机器人主要包含：智能移动平台（移动款）/智能仿真机器人',
	technology6 : '3.多语种（含中、英等语言）',
	technology7 : '4.智能或语音引导进行定点、定时讲解或宣导指定内容',
	technology8 : '5.内容可以智能检索编制或自定义修改',
	technology9 : '6.单台可以远程独立操控、多台可以远程集群化同步',
	technology10 : '智能消毒机器人',
	technology11 : '1.拥有自主知识产权（专利：2020SR0171740 / CN201811185794.8）',
	technology12 : '2.整个机器人主要包含：智能移动平台/智能灭菌消杀工作平台',
	technology13 : '3.多语种（含中、英、德等13种语言）',
	technology14 : '4.可人机共存（消毒期间，人员不用离开）',
	technology15 : '5.多消毒模式选择（环境不同可自由选择和设置）',
	technology16 : '6.可AI智控、远程应答',
	technology17 : '机构认证',
	technology18 : '企业资质',
	technology19 : '智能硬件平台',
	technology20 : '关键新型材料',
	
	homedis1 : '家庭智能消毒',
	homedis2 : '智能高功率高频悬浮雾化系统----将消毒液体近乎均匀地微粒化，使其滞空时间更长；5～100μm负电荷消毒液微粒-----自动追踪，除尘、杀菌两不误。',
	homedis3 : '加液操作',
	homedis4 : '产品参数',
	homedis5 : '规格尺寸',
	homedis6 : '225mm*225mm*295mm',
	homedis7 : '最大水容量',
	homedis8 : '3000ml',
	homedis9 : '喷雾量（可调）',
	homedis10 : '240～480g(=水量ml)/Hr.',
	homedis11 : '总功率',
	homedis12 : '28W',
	homedis13 : '消毒液雾微粒',
	homedis14 : '5～100μm',
	homedis15 : '消毒液（雾化后）微粒滞空时间',
	homedis16 : '1～6Hr.',
	homedis17 : '输入电压',
	homedis18 : 'AC 110～220V 50Hz',
	homedis19 : '单次持续工作时间',
	homedis20 : '6～12Hr.',
	homedis21 : '主体构造',
	homedis22 : '数显功能',
	homedis23 : '视频介绍',
	homedis24 : '智能消毒净化机'
	
}